import React, { FC, useEffect, useState } from 'react';
import { Button, Col, Drawer, Menu, Row } from 'antd';
import { useHistory, useParams } from 'react-router-dom';
import { ArrowSquareOut, List, SignOut } from 'common/svg';
import { Logo } from 'common/components/Logo';
import { dateFormatter } from 'common/helpers/date.helper';
import { nameBuilder } from 'common/helpers/name.helper';
import { ERoutesFranchiseePrivate, RoutesCirPrefix } from 'common/models/routesModel';
import { getSidebarMenuItems, splitMenuPath } from 'common/helpers/sidebar.helper';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { logout } from 'app/store/reducers/auth.reducer';

export const SidebarMob: FC = () => {
  const dispatch = useAppDispatch();
  const { authUser } = useAppSelector((state) => state.auth);
  const [open, setOpen] = useState<boolean>(false);
  const [openMenuKeys, setOpenMenuKeys] = useState<string[]>([]);
  const [selectedMenuKeys, setSelectedMenuKeys] = useState<string[]>([]);
  const history = useHistory();
  const { segments } = useParams<{ segments: string | undefined }>();

  // MBC-84 Phase 2: the CIR tree is permission-aware for franchisor/superadmin users.
  const menuItems = getSidebarMenuItems(false, authUser?.role, authUser?.permissions);

  useEffect(() => {
    const { itemKey } = splitMenuPath(segments);

    setSelectedMenuKeys([itemKey]);
  }, [segments]);

  useEffect(() => {
    const defaultOpenKeys = menuItems.map((item) => item.key);

    setOpenMenuKeys(defaultOpenKeys as string[]);
  }, []);

  const userName = nameBuilder(authUser?.firstName, authUser?.lastName);

  const openSidebar = () => {
    setOpen(true);
  };

  const closeSidebar = () => {
    setOpen(false);
  };

  const onOpenMenuKeysChange = (keys: string[]) => {
    setOpenMenuKeys(keys);
  };

  const redirect = (keyPath: string[]) => {
    history.push(`${RoutesCirPrefix}/${keyPath.reverse().join('/')}`);
  };

  const onLogout = () => {
    dispatch(logout());
  };

  const redirectToMBGo = () => {
    history.push(ERoutesFranchiseePrivate.StoreList);
  };

  return (
    <>
      <Button
        className={`btn-gray h-44 square ${open ? 'btn-gray-selected' : ''}`}
        icon={<List className={open ? 'icon-purple' : 'icon-gray'} />}
        onClick={openSidebar}
      />

      <Drawer
        rootClassName="menu-mob__drawer sidebar-mob"
        width={320}
        open={open}
        placement="left"
        closeIcon={null}
        onClose={closeSidebar}
        title={
          <Row gutter={8}>
            <Col flex={1}>
              <Row gutter={8}>
                <Col>
                  <Logo />
                </Col>
                <Col>
                  <div className="ff-medium fs-xs color-whiteDark">{userName}</div>
                  <span className="ff-regular fs-xxs color-gray">{`Last updated ${dateFormatter(
                    new Date().toISOString(),
                    'MM/DD/YY HH:mm'
                  )}`}</span>
                </Col>
              </Row>
            </Col>
          </Row>
        }
      >
        <Menu
          className="sidebar-mob__body"
          theme="dark"
          mode="inline"
          openKeys={openMenuKeys}
          onOpenChange={onOpenMenuKeysChange}
          selectedKeys={selectedMenuKeys}
          onSelect={({ keyPath }) => redirect(keyPath)}
          items={menuItems}
        />

        <Menu className="sidebar-mob__footer" theme="dark" mode="inline">
          <Menu.Item key="logout" className="sidebar-mob__footer-logOut" icon={<SignOut />} onClick={onLogout}>
            Log out
          </Menu.Item>
          <Menu.Item key="mbgoModule" icon={<ArrowSquareOut />} onClick={redirectToMBGo}>
            MBGo Module
          </Menu.Item>
        </Menu>
      </Drawer>
    </>
  );
};
